import { render, staticRenderFns } from "./proposal-detail.vue?vue&type=template&id=9de18480&scoped=true"
import script from "./proposal-detail.vue?vue&type=script&lang=js"
export * from "./proposal-detail.vue?vue&type=script&lang=js"
import style0 from "./proposal-detail.vue?vue&type=style&index=0&id=9de18480&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9de18480",
  null
  
)

export default component.exports